module.exports = __webpack_public_path__ + "static/media/blog_img1.a2bed255.png";